/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jul 24 2024
 **/

import styled from "@emotion/styled";

import { Column } from "@/frameworks/designStuff/components";

export const Container = styled(Column)<{ focus: boolean }>`
	width: 344px;
	height: 332px;
	border-radius: 10px;
	background-color: ${({ theme }) => theme.colors.accent_40_100};
	padding: 14px 12px 12px 12px;
	opacity: ${({ focus }) => !focus && 0.4};
`;

export const Sequence = styled.div`
	position: relative;
	width: 100%;
	height: 120px;
`;

export const SequenceImg = styled.img`
	border-radius: 12px;
	width: 100%;
	height: 100%;
`;

export const LoadingBarTotal = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 4px;
	background-color: ${({ theme }) => theme.colors.neutral_80_60};
	border-radius: 5px;
	overflow: hidden;
`;

export const LoadingBar = styled.div`
	height: 100%;
	background-color: ${({ theme }) => theme.colors.neutral_00_88};
	transition: width 0.1s linear;
`;

export const AvatarStyle = styled(Column)`
	position: absolute;
	width: 100%;
	height: 64px;
	bottom: -20px;
	z-index: 5;
`;

export const Button = styled.button<{ hasResponseData: boolean }>`
	width: max-content;
	height: 40px;
	border-radius: 100px;
	padding: 10px 20px;
	background-color: ${({ theme, hasResponseData }) =>
		hasResponseData ? theme.colors.primary_80_100 : theme.colors.neutral_80_12};
	pointer-events: ${({ hasResponseData }) => !hasResponseData && "none"};
	cursor: pointer;
`;
